import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

const AuthLayout = () => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  // console.log("userData in AuthLayout", userData);

  const navigate = useNavigate();
  useEffect(() => {
    // need a logic here a user comes from if user not entered from this route,
    // it means that user is not authenticated user, he entered here bypass..
    if (userData) {
      navigate("/app");
      // if (userData.roleId === "fV0s001") {
      //   navigate("/app");
      // }
    }
  }, [userData, navigate]);

  return !userData && <Outlet />;
};
export default AuthLayout;
